/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { SheetId } from "../../../commons/types/SheetId";
import { EnvironmentId } from "../../../commons/types/EnvironmentId";
import { SpaceId } from "../../../commons/types/SpaceId";
import { WorkbookId } from "../../../commons/types/WorkbookId";
import { AnalysisCreateDto } from "../../types/AnalysisCreateDto";
export const CreateAnalysisRequest = core.serialization.object({
    sheetId: SheetId,
    environmentId: EnvironmentId,
    spaceId: SpaceId,
    workbookId: WorkbookId,
    analyses: core.serialization.list(AnalysisCreateDto),
});
